import { db } from "../firebaseClient"
import { doc, collection, setDoc, serverTimestamp, query, where, orderBy, limit, onSnapshot } from "firebase/firestore"

// Unified append-only event log for the Control Plane — every domain write-site
// (certificates, orgs, payments, mentorships, etc.) fires one of these alongside
// its own domain-specific write. Fire-and-forget by convention, matching
// dispatchWebhook — a logging failure should never block the real action.
export const logPlatformEvent = async ({
  type,
  actorUid = null,
  actorType = "user", // "user" | "org_admin" | "platform_admin" | "system"
  orgId = null,
  targetPath,
  severity = "info", // "info" | "warning" | "critical"
  metadata = {},
}) => {
  try {
    const eventRef = doc(collection(db, "events"))
    await setDoc(eventRef, {
      eventId: eventRef.id,
      type,
      actorUid,
      actorType,
      orgId,
      targetPath,
      severity,
      metadata,
      createdAt: serverTimestamp(),
    })
    return { error: null }
  } catch (error) {
    return { error }
  }
}

// Live, filterable view of the events collection — the Event Explorer's data
// source. Each filter is an equality match; omit a key to not filter on it.
// NOTE: Firestore will likely prompt for a composite index the first time a
// given filter combination runs — click the console link, it's one-time
// setup, not a bug (same pattern as collectionGroup queries elsewhere).
export const subscribeEvents = ({ type, orgId, severity, limit: rowLimit = 50 }, cb) => {
  const clauses = []
  if (type) clauses.push(where("type", "==", type))
  if (orgId) clauses.push(where("orgId", "==", orgId))
  if (severity) clauses.push(where("severity", "==", severity))

  const q = query(
    collection(db, "events"),
    ...clauses,
    orderBy("createdAt", "desc"),
    limit(rowLimit)
  )

  return onSnapshot(
    q,
    (snap) => cb(snap.docs.map((d) => ({ id: d.id, ...d.data() })), null),
    (error) => cb([], error)
  )
}